import React, { Component } from "react";
import { connect } from "react-redux";
//IMPORT COMPONENT
import Menu         from "../Components/component_Menu";
import Loader       from "../Components/component_Loader";
import ErrorMessage from "../Components/component_MsgError";
import GoToLogin    from "../Components/component_GoToLogin";
import BuyVersion   from "../Components/component_BuyVersion";
//COMPONENTI MATERIAL UI
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import { Grid, Row, Col }                    from 'react-material-responsive-grid';
import MenuItem                              from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup }     from "material-ui/RadioButton";
import RaisedButton                          from "material-ui/RaisedButton";
import Toggle                                from 'material-ui/Toggle';
import Dialog                                from 'material-ui/Dialog';
import SelectField                           from "material-ui/SelectField";
import TextField                             from "material-ui/TextField";
import IconButton                            from 'material-ui/IconButton';
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRowColumn, TableRow, TableFooter } from "material-ui/Table";
//ICON
import IconStarBorder from "material-ui/svg-icons/toggle/star-border"
import IconStar       from "material-ui/svg-icons/toggle/star"
import IconShow       from "material-ui/svg-icons/image/remove-red-eye";
import IconRefresh    from "material-ui/svg-icons/navigation/refresh";
import IconCheck      from "material-ui/svg-icons/navigation/check";
import IconClear      from "material-ui/svg-icons/content/clear";
//ACTIONS
import { getHoldingList }         from "../Actions/Action_ServiceRequest_Holding";
import { setFavoriteTemplate, getListaStampe, setPredefiniteTemplate } from "../Actions/Action_ServiceRequest_Stampe";
import { getUserInfo } from "../Actions/Action_Authentication";
//Utils
import * as ROLES       from "../Utils/Roles_Types.js";
import * as STYLES      from "../Utils/Styles.js";
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import { checkUserLanguage } from "../Utils/Check_Value";
import "../CSS/ImageList.css";
import { LABEL_ComeBack, LABEL_PAGE_CustomPrints, LABEL_Close, LABEL_Set_As_Preferred } from "../Utils/Strings/Labels";

         
var TIMER = null;
const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERIDHOLDING = USERINFO == null ? null : USERINFO.Holding ? USERINFO.Holding.ID : null;
const USERLANGUAGE  = checkUserLanguage(USERINFO);
const CANUSEPAGE    = !(!!USERINFO) ? false :  !(USERINFO.Role.ID === ROLES.ACCOUNT_FREE_ID || USERINFO.Role.ID === ROLES.ACCOUNT_PRO_ID);

const styles = {

  cardButton : {
    padding: '0px',
    background: 'none',
    marginTop: "10px"
  },
  divStampa : {
    width: "10.5cm",
    margin : "auto",
    border : "1px solid grey"
  }
};

class Stampe extends Component {
  constructor(props) {
    super(props);

    var params = PAGESSWITCH.locationSearchToParams(this.props.location.search)

    var IDAzienda = PAGESSWITCH.searchInParamsList("IDAzienda", params, 'integer');

    this.state = {
      filter : {
        IDAzienda : IDAzienda
      },
      showTemplateDialog : {
        title : "",
        fnClose : () => { var d = this.state.showTemplateDialog; d.opened=false; d.templateID=d.templateHTML=null; this.setState({showTemplateDialog : d}) },
        opened : false,
        templateID : null,
        templateHTML : null,
      },
      iconCheck: {
        height : '100%',
        width  : "100%",
        color  : "rgba(22, 45, 77, 0.9)",
        align  : "center",
        zIndex : "999999"
      }
    }
  }

  componentDidMount(){
    if(!CANUSEPAGE) return;
    this.props.dispatch(getUserInfo());
    this.props.dispatch(getListaStampe(this.state.filter));
  }

  onChangeFavorite(template){
    var obj = {
      IDAzienda   : this.state.filter.IDAzienda,
      IDStampa    : template.ID,
      Predefinita : false,
      Preferita   : !template.Preferita
    };
    this.props.dispatch(setFavoriteTemplate(obj));
    this.forceUpdate();
  }

  onChangePredefinite(template){
    var obj = {
      IDAzienda   : this.state.filter.IDAzienda,
      IDStampa    : template.ID,
      Predefinita : !template.Predefinita,
      Preferita   : template.Preferita
    };
    this.props.dispatch(setPredefiniteTemplate(obj));
    this.forceUpdate();
  }

  onOpenShowTemplate = index => {
    var templateDialog          = this.state.showTemplateDialog;
    templateDialog.templateID   = this.props.templateList[index].ID;
    templateDialog.templateHTML = this.props.templateList[index].HTML;
    templateDialog.title        = this.props.templateList[index].Nome;
    templateDialog.opened = true;
    this.setState( { showTemplateDialog : templateDialog } )
  }

  createHTMLElement = html => <div dangerouslySetInnerHTML={{__html: html}}/>

  htmlDecode(input){
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }

  render(){

    var alertDialogAction = [ <RaisedButton label={LABEL_Close[USERLANGUAGE]} primary={true} onClick={this.state.showTemplateDialog.fnClose} /> ];

    var templ = this.state.showTemplateDialog.templateHTML;
    
    return (<div>
        <Menu 
          dispatch       = {this.props.dispatch}
          pageName       = {LABEL_PAGE_CustomPrints[USERLANGUAGE]}
          backAddress    = {"/stampanti"} 
          backButtonName = {LABEL_ComeBack[USERLANGUAGE]}
          Language       ={USERLANGUAGE}/>
          <Loader       isFetching      = {this.props.isFetching}   />
          <ErrorMessage message         = {this.props.errorMessage} />
          <GoToLogin isAuthenticated = {this.props.isAuthenticated} />
          <BuyVersion 
            visible={!CANUSEPAGE}
            Language={USERLANGUAGE}/>

          <div className="my-body">
            <div className="img-list-container">
              <ul className="img-list">
                
                {this.props.templateList && this.props.templateList.map(
                  (template, index) => 
                    <li className="img-card" key={index}>
                      <div class="sg-card-container">
	
                        <div class="sg-card">
                          <div class="image">
                            <img src={template.Image}/>
                          </div>
                          <div class="sg-card-title center-el" onClick={(event) => this.onOpenShowTemplate(index)}>
                            {template.Nome}
                          </div>
                          {template.Preferita == true && <div class="checked">
                              <IconCheck style={this.state.iconCheck}/>
                          </div>}
                          <div class="sg-new-card-buttons clearfix">
                            { template.Preferita == true && <div class="sg-card-btn left center-el">
                              <IconButton
                                style={styles.large}
                                onClick={(event) => this.onChangePredefinite(template)}
                                tooltip={LABEL_Set_As_Preferred[USERLANGUAGE]}
                              >
                                {template.Predefinita ? <IconStar/> : <IconStarBorder/>}
                              </IconButton>
                            </div>}
                            <div class="sg-card-btn right center-el">
                              <IconButton
                                style={styles.large}
                                onClick={(event) => this.onChangeFavorite(template)}
                                tooltip={template.Preferita ? "Elimina dai Preferiti" : LABEL_Set_As_Preferred[USERLANGUAGE]}
                              >
                                {template.Preferita ? <IconClear/> : <IconCheck/>}
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                )}

              </ul>
              
            </div>
          </div>
          <Dialog 
              autoScrollBodyContent={true}
              title={this.state.showTemplateDialog.title}
              actions={alertDialogAction}
              modal={true}
              contentStyle={this.state.showTemplateDialog.style}
              open={this.state.showTemplateDialog.opened}
            >
              <div 
              className = "template-container">
                <div style={styles.divStampa} className="template-stampa">

                  {this.state.showTemplateDialog.opened && 
                     this.createHTMLElement(templ)}
                </div>
              </div>
            
           </Dialog>
    </div>);
  }
}

function mapStateToProps(state) {
  const { stampeReducer } = state;
  const { isFetching, isAuthenticated, errorMessage, templateList } = stampeReducer;
  return {
    isFetching,
    isAuthenticated,
    errorMessage,
    templateList
  };
}

export default connect(mapStateToProps)(Stampe);


// WEBPACK FOOTER //
// ./src/Containers/Stampe.js